var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',{style:(_vm.secondaryBackground),attrs:{"id":"cts_top_page"}},[_c('MainContent')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }